import React from 'react';

function AccountDetails({ lvAccountDetails }) {
  return (
    <section>
      <div className='space-y-1'>
        <p className='flex flex-row justify-between'>
          {' '}
          <span className='text-s-bk text-sm'>Account name</span>
          {lvAccountDetails?.payment?.lv_account?.account_name}
        </p>
        <p className='flex flex-row justify-between'>
          {' '}
          <span className='text-s-bk text-sm'>FX amount</span>
          {(lvAccountDetails?.payment?.cx_amount * 1)?.toLocaleString()}
          {' ' + lvAccountDetails?.cx?.quote_currency?.symbol}
        </p>

        <p className='flex flex-row justify-between'>
          {' '}
          <span className='text-s-bk text-sm'>Account location</span>
          {lvAccountDetails.payment?.lv_account?.country?.name}
        </p>

        {lvAccountDetails?.payment?.type === 'local' && (
          <div>
            <p className='flex flex-row justify-between'>
              <span className='text-s-bk text-sm'>Bank name</span>
              {lvAccountDetails?.payment?.lv_account?.local?.bank_name}
            </p>
            <p className='flex flex-row justify-between'>
              {' '}
              <span className='text-s-bk text-sm'>Account number</span>
              {lvAccountDetails.payment?.lv_account?.local?.account_number}
            </p>
          </div>
        )}
        {lvAccountDetails?.payment?.type === 'cx' && (
          <div>
            <p className='flex flex-row justify-between'>
              {' '}
              <span className='text-s-bk text-sm'>Bank address</span>
              {lvAccountDetails?.payment?.lv_account?.cx?.bank_address}
            </p>
            <p className='flex flex-row justify-between'>
              {' '}
              <span className='text-s-bk text-sm'>Bank name</span>
              {lvAccountDetails?.payment?.lv_account?.cx?.bank_name}
            </p>
            <p className='flex flex-row justify-between'>
              {' '}
              <span className='text-s-bk text-sm'>Iban number</span>
              {lvAccountDetails?.payment?.lv_account?.cx?.iban_number}
            </p>
            <p className='flex flex-row justify-between'>
              {' '}
              <span className='text-s-bk text-sm'>Swift code</span>
              {lvAccountDetails?.payment?.lv_account?.swift_code}
            </p>
          </div>
        )}

        <p className='flex flex-row justify-between'>
          {' '}
          <span className='text-s-bk text-sm'>Rate</span>
          {Number(lvAccountDetails?.payment?.rate)?.toFixed(4) +
            ' ' +
            lvAccountDetails?.payment?.lv_account?.currency?.symbol}
        </p>
        <p className='flex flex-row justify-between'>
          {' '}
          <span className='text-s-bk text-sm'>Transaction fee</span>
          {`${Number(lvAccountDetails?.payment?.bidder_commission)?.toFixed(
            4
          )} ${lvAccountDetails?.payment?.lv_account?.currency?.symbol}`}
        </p>
        <p className='flex flex-row justify-between border-dashed border-y-hf font-semibold border-t-bk py-2 '>
          <span className=' text-sm'>Total amount</span>
          {`${(lvAccountDetails?.payment?.grand_total * 1)?.toLocaleString()} ${
            lvAccountDetails?.payment?.lv_account?.currency?.symbol
          }`}
        </p>
      </div>
    </section>
  );
}

export default AccountDetails;
